import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import OrderItemRightUI from '../order/OrderItemRightUI'
import OrderItemLeftUI from '../order/OrderItemLeftUI'

const InvoiceItemListUI = ({context, messageList, invoiceItemList,
    searchFilter, onRefreshClick, onSearchFilterChange, onUpdateClick
  }) =>
  <div className='inv_invoice g_m_top_100'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        invoiceItemList.map((item, i) =>
          <ItemRowUI key={i} context={context} messageList={messageList} item={item} />
        )
      }
    </LRTableBodyUI>
  </div>

const ItemRowUI = ({context, item, messageList}) =>
  <LRTableRowUI
    context={context}
    left={<OrderItemLeftUI context={context} messageList={messageList} item={item} />}
    right={<OrderItemRightUI context={context} messageList={messageList} item={item} />}
  />

const ActionLeftUI = ({context, messageList, onRefreshClick, onUpdateClick
  }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_invoice' />
    }
  </div>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange
  }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default InvoiceItemListUI
